var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-percentage"},[_c('div',{staticClass:"bar-percentage__progress",class:_vm.passed
        ? 'bar-percentage__progress--success'
        : 'bar-percentage__progress--fail',style:(("width: " + _vm.percentage + "%;"))})])}
var staticRenderFns = []

export { render, staticRenderFns }